import { Link, useLocation } from "react-router-dom";

// Slim site footer present on every page. Two responsibilities:
// (1) make the Privacy + Terms links discoverable from anywhere; (2) sit
// quietly so it never competes with the page content above it. Renders
// nothing on the Privacy and Terms pages themselves — those pages have
// their own headers and links back home.
export default function SiteFooter() {
  const { pathname } = useLocation();
  if (pathname === "/privacy" || pathname === "/terms") return null;
  return (
    <footer
      data-testid="site-footer"
      className="mt-20 border-t border-[#4a6984]/12 bg-white/60 backdrop-blur-sm"
    >
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-[#4a6984]/75 font-semibold">
        <span data-testid="footer-crafted-line">
          Crafted in Canada · For Ontario Educators
        </span>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          <Link
            to="/dashboard"
            data-testid="footer-dashboard-link"
            className="hover:text-[#1c2d3d] uppercase tracking-[0.14em]"
          >
            Teacher Dashboard
          </Link>
          <Link
            to="/samples"
            data-testid="footer-samples-link"
            className="hover:text-[#1c2d3d] uppercase tracking-[0.14em]"
          >
            Samples
          </Link>
          <Link
            to="/classroom-support"
            data-testid="footer-classroom-support-link"
            className="hover:text-[#1c2d3d] uppercase tracking-[0.14em]"
          >
            Classroom Support
          </Link>
          <Link
            to="/pricing"
            data-testid="footer-pricing-link"
            className="hover:text-[#1c2d3d] uppercase tracking-[0.14em]"
          >
            Pricing
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[#1c2d3d] uppercase tracking-[0.14em]"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[#1c2d3d] uppercase tracking-[0.14em]"
          >
            Terms
          </Link>
          <Link
            to="/contact"
            data-testid="footer-contact-link"
            className="hover:text-[#1c2d3d] uppercase tracking-[0.14em]"
          >
            Contact
          </Link>
        </nav>
        <span data-testid="footer-copyright" className="text-[11px] text-[#4a6984]/60">
          © {new Date().getFullYear()} Atomic Edu
        </span>
      </div>
    </footer>
  );
}
